import React from 'react'
import { Box, Typography, styled } from '@mui/material';
import { useIsOnMobile } from '../../hooks/layoutHooks';

const FooterContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(1.5, 2),
  marginTop: 'auto',
  background: 'linear-gradient(90deg, #1a1a1a 0%, #121212 100%)',
  color: "white",
  textAlign: 'center',
  width: "100%",
  height: "50px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexShrink: 0,
  boxShadow: '0 -2px 10px rgba(0, 0, 0, 0.3)',
  borderTop: '2px solid #dc3545',
  [theme.breakpoints.down("md")]: {
    padding: theme.spacing(1, 1),
    height: "45px",
  },
}));

export const AppFooter = () => {
  const isMobile = useIsOnMobile()
  const currentYear = new Date().getFullYear()
  
  return (
    <FooterContainer component="footer">
      <Typography 
        variant={isMobile ? "body2" : "body1"} 
        sx={{ 
          color: "rgba(255,255,255,0.9)",
          fontWeight: 500,
          letterSpacing: '0.5px',
          fontSize: { xs: '0.75rem', md: '0.875rem' },
          display: 'flex',
          alignItems: 'center',
          gap: 1
        }}
      >
        <span style={{ 
          color: "#dc3545", 
          fontWeight: 700,
          fontSize: isMobile ? '0.85rem' : '1rem',
          letterSpacing: '1.5px'
        }}>
          SKEIDAR
        </span>
        <span style={{ color: "rgba(255,255,255,0.6)" }}>|</span>
        <span>© {currentYear} All rights reserved.</span>
      </Typography>
    </FooterContainer>
  );
};

